import { render } from "./App.vue?vue&type=template&id=58feee07"
const script = {}

import "./App.vue?vue&type=style&index=0&id=58feee07&lang=scss"

import exportComponent from "../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.4.37_vue@3.4.37_typescript@5.5.4__webpack@5.93.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__